export const REQUEST_ARTISTS = 'concrete/REQUEST_ARTISTS'
export const RECEIVE_ARTISTS = 'concrete/RECEIVE_ARTISTS'
export const ERROR_ARTISTS = 'concrete/ERROR_ARTISTS'
export const SET_ARTISTS_ENABLED = 'concrete/SET_ARTISTS_ENABLED'


// WEBPACK FOOTER //
// ./src/components/artist-list-container/action-types.js